import {useSearchParams} from 'react-router-dom';
import {AppQuery, getSearchFromQuery} from 'utilities/url';

export function useUrlParams() {
  const [params, setParams] = useSearchParams();

  const urlParams: AppQuery = {};
  params.forEach((value, key) => {
    urlParams[key as keyof AppQuery] = value;
  });

  const setUrlParams = (newParams: AppQuery) => {
    const paramsToSet = {...urlParams};
    for (const [key, value] of Object.entries(newParams)) {
      if (value) {
        paramsToSet[key as keyof AppQuery] = value;
      } else {
        delete paramsToSet[key as keyof AppQuery];
      }
    }

    setParams(getSearchFromQuery(paramsToSet), {replace: true});
  };

  return {urlParams, setUrlParams};
}
